<template>
  <v-expansion-panels
    class="accordion-drilldown"
    accordion
  >
    <v-expansion-panel
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
    >
      <v-expansion-panel-header>
        <BaseEntityBadge
          :initials="item.entity.initials"
          :name="item.entity.name"
          :meta="item.entity.meta"
        />
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-tabs
          :value="getActiveTab(itemIndex)"
          dense
          @change="(value) => setActiveTab(itemIndex, value)"
        >
          <v-tab
            v-for="(tab, tabIndex) in item.tabs"
            :key="tabIndex"
          >
            {{ tab.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items :value="getActiveTab(itemIndex)">
          <v-tab-item
            v-for="(tab, tabIndex) in item.tabs"
            :key="tabIndex"
          >
            <div class="accordion-drilldown__tab-content">
              <slot
                name="tab-content"
                :item="item"
                :item-index="itemIndex"
                :tab="tab"
                :tab-index="tabIndex"
              />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import BaseEntityBadge from './BaseEntityBadge.vue'

const LONG_LIST_WARNING_THRESHOLD = 15

export default {
  name: 'BaseAccordionDrilldown',
  components: { BaseEntityBadge },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeTab: {}
    }
  },
  created() {
    if (process.env.NODE_ENV !== 'production' && this.items.length > LONG_LIST_WARNING_THRESHOLD) {
      // eslint-disable-next-line no-console
      console.warn(
        `BaseAccordionDrilldown: recebeu ${this.items.length} itens (> ${LONG_LIST_WARNING_THRESHOLD}). ` +
        'Listas longas quebram a leitura neste componente — considere usar o BaseDetailDrawer.'
      )
    }
  },
  methods: {
    getActiveTab(itemIndex) {
      return this.activeTab[itemIndex] || 0
    },
    setActiveTab(itemIndex, tabIndex) {
      this.$set(this.activeTab, itemIndex, tabIndex)
    }
  }
}
</script>

<style lang="scss">
.accordion-drilldown {
  &__tab-content {
    padding: 16px 4px 4px;
  }
}
</style>
